import React, { useState } from 'react';
import { Card } from '../shadcn-ui/card';
import { ChevronDown, ChevronUp, Pencil } from 'lucide-react';
import { formatReadableDate } from '@/pages/storage-screens/StorageLotDetailPage';
import UpdateStorageLotDrawer from './UpdateStorageLotDrawer';

const StorageLotDetailCard = ({ lot, idx, fetchStorageDetailLots }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card className="flex justify-between p-3">
      <div className="mr-2 flex flex-1 flex-col overflow-hidden">
        <div className="font-medium">
          {/* {item?.sequence_no}. {formatDateTime(item?.time_of_check)} */}
          {idx + 1}. {lot?.storage_label || 'N/A'}
        </div>
        {!open ? (
          <div className="mt-1 text-sm text-secondary-foreground">
            <div className="flex items-center gap-1">
              <div className="inline-block font-medium">Weight:</div> {lot?.total_weight || 'N/A'}kg
              <div className="inline-block font-medium">• Moisture:</div> {lot?.moisture_1 || 'N/A'}%
            </div>

            <div className="flex items-center gap-1">
              <div className="inline-block font-medium">• Bags:</div> {lot?.bags || 'N/A'}
              <div className="inline-block font-medium">• Available weight:</div>{' '}
              {lot?.total_weight != null ? `${(lot.total_weight - (lot.consumption_weight || 0)).toFixed(2)}kg` : 'N/A'}
            </div>
          </div>
        ) : (
          <div className="mt-1 text-sm text-secondary-foreground">
            <div className="flex items-center gap-1">
              <div className="font-medium">Date of storage: </div>
              {formatReadableDate(lot?.date_of_storage)}
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Weight: </div>
              {lot?.total_weight || 'N/A'}kg
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Moisture 1: </div>
              {`${lot?.moisture_1}%` || 'N/A'}
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Moisture 2: </div>
              {lot?.moisture_2 != null ? `${lot.moisture_2}%` : 'N/A'}
            </div>
            <div className="flex items-center gap-1">
              <div className="font-medium">Bags: </div>
              {lot?.bags || 'N/A'}
            </div>
            <div className="mb-1 flex items-center gap-1">
              <div className="font-medium">Comments: </div>
              {lot?.comments || 'N/A'}
            </div>
          </div>
        )}
      </div>
      <div className="mt-2 flex items-start justify-start gap-2">
        {/* <button className="mr-1 flex-shrink-0">
          <Pencil className="h-5 w-5" />
        </button> */}
        <UpdateStorageLotDrawer lot={lot} fetchStorageDetailLots={fetchStorageDetailLots} />
        <button className="mr-1 flex-shrink-0" onClick={() => setOpen(!open)}>
          {open ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
        </button>
      </div>
    </Card>
  );
};

export default StorageLotDetailCard;
